/**
 * Last-pointer kind (plan T3): the shell records whether the most recent pointer event on the
 * stage came from a coarse pointer (`pointerType === 'touch'`). HUD affordances that rely on
 * hover switch their wording on it (the inset's CLICK/TAP TO FOLLOW chip). Desktop mouse input
 * leaves it false, so desktop text and pixels are unchanged.
 */
let lastTouch = false;

export function setLastPointerTouch(touch: boolean): void {
  lastTouch = touch;
}

export function lastPointerIsTouch(): boolean {
  return lastTouch;
}
